// extracted by mini-css-extract-plugin
export var infoItem = "_tb-2";
export var title = "_tb-0";
export var value = "_tb-1";